import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

export function ChatRefPicker({ currentUser, onClose, onPick }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [tab, setTab] = useState('recipe');
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true); setItems([]);
    let p = null;
    if (tab === 'recipe') p = api('GET', '/api/recipes', null, headers).then(r => r.recipes || []);
    else if (tab === 'task') p = api('GET', '/api/tasks/import-template-list', null, headers)
      .catch(() => api('GET', '/api/tasks/4', null, headers).then(rs => rs.map(t => ({ id: t.id, title: t.title, time_period: t.time_period }))));
    else if (tab === 'knowledge') p = api('GET', '/api/knowledge-docs', null, headers).then(r => r.documents || r.docs || []);
    if (p) p.then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
    else setLoading(false);
  }, [tab]);

  const filtered = (q.trim() ? items.filter(it => {
    const text = (it.name || it.title || '').toLowerCase();
    return text.includes(q.trim().toLowerCase());
  }) : items).slice(0, 100);

  function pick(it) {
    const kind = tab;
    const label = it.name || it.title || `${kind} ${it.id}`;
    onPick({ kind, id: it.id, label });
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl flex flex-col fade-in shadow-2xl"
           style={{ maxHeight: '85vh' }}
           onClick={e => e.stopPropagation()}>
        <div className="bg-ink rounded-t-2xl p-5 flex items-center justify-between flex-shrink-0">
          <h3 className="text-cream font-bold text-base">Attach</h3>
          <button onClick={onClose} className="text-cream/50 hover:text-cream text-3xl leading-none">×</button>
        </div>
        <div style={{ display: 'flex', borderBottom: '1px solid #e0e0e0', flexShrink: 0 }}>
          {[
            { id: 'recipe',    label: '🍵 Recipes' },
            { id: 'task',      label: '☑ Tasks' },
            { id: 'knowledge', label: '📄 SOPs' },
          ].map(t => (
            <button key={t.id} onClick={() => { setTab(t.id); setQ(''); }}
              style={{ flex: 1, padding: '10px 8px', fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
                        background: 'transparent', border: 'none',
                        borderBottom: `3px solid ${tab === t.id ? 'var(--forest)' : 'transparent'}`,
                        color: tab === t.id ? '#212121' : '#757575', cursor: 'pointer' }}>
              {t.label}
            </button>
          ))}
        </div>
        <div style={{ padding: '10px 14px 0', flexShrink: 0 }}>
          <input value={q} onChange={e => setQ(e.target.value)} placeholder={`Search ${tab}s…`}
            style={{ width: '100%', padding: '8px 10px', fontSize: 13, border: '1px solid #d0d4d9', borderRadius: 6, fontFamily: 'inherit' }} />
        </div>
        <div style={{ overflowY: 'auto', flex: 1, minHeight: 0, padding: 12 }}>
          {loading ? (
            <div style={{ color: '#9e9e9e', fontSize: 12 }}>Loading…</div>
          ) : filtered.length === 0 ? (
            <div style={{ color: '#9e9e9e', fontSize: 12 }}>No matches.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {filtered.map(it => (
                <button key={it.id} onClick={() => pick(it)}
                  style={{ display: 'block', width: '100%', textAlign: 'left',
                            padding: '8px 10px', border: '1px solid #e0e0e0', borderRadius: 6,
                            background: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#212121' }}>
                    {it.name || it.title}
                  </div>
                  <div style={{ fontSize: 11, color: '#9e9e9e' }}>
                    {it.category || it.type || it.time_period || ''}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
